import axios from "axios";

const BaseUrl = "https://example.com"; // Замените на реальный BaseUrl

export default {
  namespaced: true,
  state: () => ({
    calculators: [
      {
        id: "1",
        destination_city: "Москва",
        destination_region: "Московская область",
        departure_city: "Санкт-Петербург",
        departure_region: "Ленинградская область",
        load_date: "2024-01-20T10:00:00",
        upload_date: "2024-01-21T18:00:00",
        client_price_without_nds: 100000.0,
        cost_to_carrier_without_nds: 80000.0,
        margin_without_nds: 20000.0,
        cost_to_carrier_with_nds: 96000.0,
        client_price_with_nds: 120000.0,
        margin_with_nds: 24000.0,
        fond_cost: 5000.0,
        kpi: 98.5,
        status: "Активен",
        update_dt: "2024-01-19T15:30:00",
        create_dt: "2024-01-18T12:00:00",
      },
      {
        id: "2",
        destination_city: "Казань",
        destination_region: "Республика Татарстан",
        departure_city: "Екатеринбург",
        departure_region: "Свердловская область",
        load_date: "2024-01-22T09:30:00",
        upload_date: "2024-01-23T16:45:00",
        client_price_without_nds: 75000.0,
        cost_to_carrier_without_nds: 60000.0,
        margin_without_nds: 15000.0,
        cost_to_carrier_with_nds: 72000.0,
        client_price_with_nds: 90000.0,
        margin_with_nds: 18000.0,
        fond_cost: 4000.0,
        kpi: 97.2,
        status: "В ожидании",
        update_dt: "2024-01-21T14:20:00",
        create_dt: "2024-01-20T11:00:00",
      },
      {
        id: "3",
        destination_city: "Новосибирск",
        destination_region: "Новосибирская область",
        departure_city: "Омск",
        departure_region: "Омская область",
        load_date: "2024-01-25T08:15:00",
        upload_date: "2024-01-26T14:30:00",
        client_price_without_nds: 50000.0,
        cost_to_carrier_without_nds: 40000.0,
        margin_without_nds: 10000.0,
        cost_to_carrier_with_nds: 48000.0,
        client_price_with_nds: 60000.0,
        margin_with_nds: 12000.0,
        fond_cost: 3000.0,
        kpi: 95.8,
        status: "Завершен",
        update_dt: "2024-01-24T17:10:00",
        create_dt: "2024-01-23T09:45:00",
      },
    ], // Список расчетов
    sortBy: null, // Поле для сортировки
    sortOrder: "asc", // Направление сортировки: "asc" или "desc"
  }),
  mutations: {
    SET_CALCULATORS(state, calculators) {
      state.calculators = calculators;
    },
    ADD_OR_UPDATE_CALCULATOR(state, calculator) {
      const index = state.calculators.findIndex((item) => item.id === calculator.id);
      if (index !== -1) {
        state.calculators.splice(index, 1, calculator); // Обновить существующий расчет
      } else {
        state.calculators.push(calculator); // Добавить новый расчет
      }
    },
    SET_SORT_BY(state, sortBy) {
      state.sortBy = sortBy;
    },
    SET_SORT_ORDER(state, sortOrder) {
      state.sortOrder = sortOrder;
    },
  },
  actions: {
    // Отправка формы
    async sendCalculatorForm({ commit }, formData) {
      const token = localStorage.getItem("user.access_token");
      try {
        const response = await axios.post(`${BaseUrl}/trade/calculators`, formData, {
          headers: { Authorization: `Bearer ${token}` },
        });
        commit("ADD_OR_UPDATE_CALCULATOR", response.data); // Добавить/обновить расчет в store
      } catch (error) {
        throw new Error(error.response?.data || "Failed to send calculator form");
      }
    },

    // Получение всех расчетов
    async fetchCalculators({ commit }) {
      const token = localStorage.getItem("user.access_token");
      try {
        const response = await axios.get(`${BaseUrl}/trade/calculators`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        commit("SET_CALCULATORS", response.data); // Сохранить расчеты в store
      } catch (error) {
        throw new Error(error.response?.data || "Failed to fetch calculators");
      }
    },

    // Сортировка расчетов
    sortCalculators({ commit, state }, { field, order }) {
      const sortedCalculators = [...state.calculators].sort((a, b) => {
        if (a[field] < b[field]) return order === "asc" ? -1 : 1;
        if (a[field] > b[field]) return order === "asc" ? 1 : -1;
        return 0;
      });
      
      commit("SET_CALCULATORS", sortedCalculators);
      commit("SET_SORT_BY", field);
      commit("SET_SORT_ORDER", order);
    },
  },
  getters: {
    // Получить список расчетов с сортировкой
    sortedCalculators(state) {
      if (!state.sortBy) {
        return state.calculators;
      }

      const calculators = [...state.calculators];
      const field = state.sortBy;
      const order = state.sortOrder;

      return calculators.sort((a, b) => {
        if (a[field] < b[field]) return order === "asc" ? -1 : 1;
        if (a[field] > b[field]) return order === "asc" ? 1 : -1;
        return 0;
      });
    },
  },
};
